export const TARGET_TYPES = [
  'political',
  'country',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'colloquial_area',
  'locality',
  'natural_feature',
]

/**
 * Handle an autocomplete request
 * @param {*} GoogleMaps - The api object
 * @param {Object[]} results - The search results
 * @param {string} status - A PlacesServiceStatus
 * @return {*}
 */
export function onAutocompleteRequest({ GoogleMaps }, results, status) {
  const { OK, NOT_FOUND, ZERO_RESULTS } = GoogleMaps.places.PlacesServiceStatus

  if (status === OK) {
    return results
  }

  if ([NOT_FOUND, ZERO_RESULTS].includes(status)) {
    return []
  }

  return handleNotOk({ GoogleMaps }, status)
}

export function onGetDetailsRequest({ GoogleMaps }, result, status) {
  const { OK, NOT_FOUND, ZERO_RESULTS } = GoogleMaps.places.PlacesServiceStatus

  if (status === OK) {
    return result.geometry.location.toJSON()
  }

  if ([NOT_FOUND, ZERO_RESULTS].includes(status)) {
    return { lat: 0, lng: 0 }
  }

  return handleNotOk({ GoogleMaps }, status)
}

/**
 * Handle all status that are related to errors
 * @param {*} GoogleMaps - The api object
 * @param {string} status - A PlacesServiceStatus
 */
function handleNotOk({ GoogleMaps }, status) {
  const { INVALID_REQUEST, OVER_QUERY_LIMIT, REQUEST_DENIED, UNKNOWN_ERROR } =
    GoogleMaps.places.PlacesServiceStatus

  if ([INVALID_REQUEST, OVER_QUERY_LIMIT, REQUEST_DENIED, UNKNOWN_ERROR].includes(status)) {
    throw new Error(`Request failed! Error status: ${status}`)
  }
}
